export const productDefaultImage = <T extends { src: string }>(images?: T[]): T | undefined => {
  images = images || [];
  return images.find((x) => x.src.includes('/original/') && x.src.endsWith('-0003')) || images[0];
};

export const productTileImage = (images?: string[]): string | undefined => {
  images = images || [];
  return images.find((x) => x.includes('/original/') && x.endsWith('-0003')) || images[0];
};

export const product360Sprite = (images?: string[]): string | undefined => {
  images = images || [];
  return images.find((x) => x.includes('/original/') && x.endsWith('-360'));
};

export const productDetailPageImages = (images?: string[]): string[] => {
  images = images || [];
  return images.filter((x) => x.includes('/original/') && !x.endsWith('-360'));
};

const productImagesSort = (a: string, b: string) => {
  const order = ['-0003', '-WORN1', '-0000', '-0008', '-WORN2', '-0015', '-0022'];

  const getOrderIndex = (str: string) => {
    for (let i = 0; i < order.length; i++) {
      if (str.endsWith(order[i])) {
        return i;
      }
    }
    return order.length;
  };

  return getOrderIndex(a) - getOrderIndex(b);
};

export const sortProductImages = (images?: string[]) => (images || []).sort(productImagesSort);

export const getOpenGraphImages = (images?: string[]) =>
  sortProductImages(productDetailPageImages(images)).map(getImageOfSize.bind(null, null));

const MAPPING: Record<string, string> = {
  small: '/grnld-r200/',
  medium: '/grnld-r600/',
  large: '/xxl/',
};
export const getImageOfSize = (suffix: string | null | undefined, source: string) =>
  suffix && MAPPING[suffix]
    ? source.replace('/original/', MAPPING[suffix])
    : source.replace('/original/', '/grnld-r900/');
